/*
  formatDisplayAnswer
  - Converts stored structured answers into human-readable strings for UI
  - Safe to use with null/undefined values
*/

export default function formatDisplayAnswer(subq, value) {
  if (value === null || value === undefined) return 'No answer given';

  // Arrays (selectMultiple)
  if (Array.isArray(value)) {
    if (value.length === 0) return 'No answer given';
    return value.map(v => (typeof v === 'object' && v !== null)
      ? (v.otherValue ? `${v.value}: ${v.otherValue}` : `${v.value}`)
      : `${v}`).join(', ');
  }

  // Objects (selectOne)
  if (typeof value === 'object') {
    if (value.otherValue) return `${value.value}: ${value.otherValue}`;
    if (value.value !== undefined) return `${value.value}`;
  }

  // Primitive
  return `${value}`;
}


